import { createContext, PropsWithChildren, useEffect } from 'react';
import { useLocation } from 'react-router';

type FeatureFlagContextType = {};

export const FeatureFlagContext = createContext<FeatureFlagContextType>({});

export default FeatureFlagContext;

export const FeatureFlagContextProvider: React.FC<PropsWithChildren<{}>> = ({ children }) => {
    const logPrefix = '[FeatureFlagContextProvider]';
    const location = useLocation();

    useEffect(() => {
        return () => {
            const params = new URLSearchParams(location.search);
            for (const p of params.entries()) {
                const key = p[0];
                const val = p[1];
                if (key.startsWith('FEATURE_FLAG_')) {
                    localStorage.setItem(key, val);
                    console.log(`${logPrefix} override feature flag ${key} to ${val}`);
                }
            }
        };
    }, [location.search]);

    return <FeatureFlagContext.Provider value={{}}>{children}</FeatureFlagContext.Provider>;
};
